import type { Playlist } from '../../../components/display/data/types';
import type {
  PlaylistFetchRequestPayload, PlaylistCreateRequestPayload, PlaylistUpdateRequestPayload, PlaylistDeleteRequestPayload,
} from './playlistTypes';
import {
  PLAYLIST_FETCH_REQUEST, PLAYLIST_FETCH_SUCCESS, PLAYLIST_FETCH_FAILURE,
  PLAYLIST_CREATE_REQUEST, PLAYLIST_UPDATE_REQUEST, PLAYLIST_DELETE_REQUEST,
  PLAYLIST_ADD, PLAYLIST_UPDATE, PLAYLIST_DELETE,
} from './playlistTypes';

export const playlistFetchRequest = (payload: PlaylistFetchRequestPayload) => ({ type: PLAYLIST_FETCH_REQUEST as typeof PLAYLIST_FETCH_REQUEST, payload });
export const playlistFetchSuccess = (items: Playlist[]) => ({ type: PLAYLIST_FETCH_SUCCESS as typeof PLAYLIST_FETCH_SUCCESS, payload: items });
export const playlistFetchFailure = (error: string) => ({ type: PLAYLIST_FETCH_FAILURE as typeof PLAYLIST_FETCH_FAILURE, payload: error });

export const playlistCreateRequest = (payload: PlaylistCreateRequestPayload) => ({ type: PLAYLIST_CREATE_REQUEST as typeof PLAYLIST_CREATE_REQUEST, payload });
export const playlistUpdateRequest = (payload: PlaylistUpdateRequestPayload) => ({ type: PLAYLIST_UPDATE_REQUEST as typeof PLAYLIST_UPDATE_REQUEST, payload });
export const playlistDeleteRequest = (payload: PlaylistDeleteRequestPayload) => ({ type: PLAYLIST_DELETE_REQUEST as typeof PLAYLIST_DELETE_REQUEST, payload });

export const playlistAdd = (item: Playlist) => ({ type: PLAYLIST_ADD as typeof PLAYLIST_ADD, payload: item });
export const playlistUpdate = (item: Playlist) => ({ type: PLAYLIST_UPDATE as typeof PLAYLIST_UPDATE, payload: item });
export const playlistDelete = (id: string) => ({ type: PLAYLIST_DELETE as typeof PLAYLIST_DELETE, payload: id });
